import {ActivatedRouteSnapshot, CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {inject} from '@angular/core';
import {UserAuthenticationService} from '../services/user-authentication.service';
import {LocalStorageService} from '../local-storage.service';
import {Observable} from 'rxjs';
import {HelperService} from '../services/helper.service';

export const AuthenticatedGuard: CanActivateFn = (route) => {
    const userAuth = inject(UserAuthenticationService);
    const router = inject(Router);

    if (!userAuth.getCurrentAuthenticatedUser()) {
        const localStorage = inject(LocalStorageService);
        const helperService = inject(HelperService);
        return new Observable<boolean | RedirectCommand>((observer) => {
            Promise.all([
                localStorage.get('userName', 'SwissWebConfigDB', true),
                localStorage.get('userPW', 'SwissWebConfigDB', true),
                localStorage.get('userMandant', 'SwissWebConfigDB', true, []),
                localStorage.get('autoLogin', 'SwissWebConfigDB', true, false)
            ]).then(userData => {
                if (!userData[0] || !userData[1] || !userData[2]) {
                    observer.next(false);
                    observer.complete();
                }
                userAuth.loginUser({userName: userData[0], userPW: userData[1], mandant: '', mandantID: userData[2]}).then(async (res: boolean) => {
                    if (!res || !userData[3]) {
                        observer.next(new RedirectCommand(router.parseUrl('login/401')));
                    } else {
                        await setURL(helperService, route);
                        await userAuth.loadAnwenderData();
                        observer.next(true);
                    }
                    observer.complete();
                });
            }).catch(() => {
                observer.next(new RedirectCommand(router.parseUrl('login/')));
                observer.complete();
            });
        });
    } else {
        return new Promise(async resolve => {
            const userLicenseInfo = await userAuth.getUserLicenses();
            if (userLicenseInfo.otherRegistrationExists) {
                resolve(new RedirectCommand(router.parseUrl('login/401')));
            } else {
                resolve(true);
            }
        });
    }
};

const setURL = async (helperService: HelperService, route: ActivatedRouteSnapshot) => {
    let stringURL = '';
    route.url.forEach(val => {
        stringURL += '/' + val.path;
    });
    await helperService.setPageRefreshURL(stringURL);
};
